// extracted by mini-css-extract-plugin
module.exports = {"empty":"scrollbars_empty__1jdLf","thin":"scrollbars_thin__2iVX6"};